import gql from "graphql-tag";

export const GET_CATEGORIES_HOME_MENU = gql`
  query getCategoriesHomePageMenu {
    getCategoriesHomePageMenu {
      nepaliName
      permalink
    }
  }
`;

export const GET_CATEGORY_BY_PERMALINK = gql`
  query getCatInfoByPermalink($permalink: String!) {
    getCatInfoByPermalink(permalink: $permalink) {
      _id
      nepaliName
      englishName
      permalink
      catInfo
      subCategories {
        nepaliName
        permalink
      }
    }
  }
`;

export const GET_CATEGORIES_SIDE_MENU = gql`
  query getCategoriesSideMenu {
    getCategoriesSideMenu {
      nepaliName
      permalink
      categoryHeading
      subCategories {
        categoryHeading
        nepaliName
        permalink
      }
    }
  }
`;
